import axios from 'axios'

export const placeImage = (file) => {
  let Office = window.Office

  let url = file.url.replace('http://', 'https://')
  // let size = ((file.type === 'svg') ? 512 : file.size) || 512

  let requestParams = {
    url,
    responseType: 'arraybuffer'
  }

  axios(requestParams).then(response => {
    // Get the file data in an array
    let buf = new Uint8Array(response.data)
    let out = ''
    for (let i = 0, length = buf.length; i < length; i += 1) { out += String.fromCharCode(buf[i]) }

    // Base64 String
    let fileData = window.btoa(out)

    // Insert Image into Office App
    let assetData = fileData
    let options = {
      coercionType: Office.CoercionType.Image
    }

    Office.context.document.setSelectedDataAsync(assetData, options, function (asyncResult) {})
  })
    .catch((e) => {
      console.error(e)
    })
}
